export function propFilter(keyword, targets, props) {
  let lKeyword = keyword
  let lTargets = targets
  let lProps = props

  if (typeof keyword === 'object') {
    lKeyword = keyword.search
    lTargets = keyword.list || []
    lProps = keyword.searchFields
  }

  const kw = lKeyword.trim().toLowerCase()

  return lTargets.filter((target) =>
    lProps.some((prop) => String(target[prop]).toLowerCase().indexOf(kw) !== -1)
  )
}

export default {
  propFilter,
}
